import { styled } from '@mui/material';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  color: theme.palette.common.white,
  padding: '3.5rem 1rem 2rem 1rem',
  flexGrow: 1,
}));

export const MainTitle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.75rem',
}));

export const Content = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  gap: '2.5rem',
  justifyContent: 'flex-start',
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '1rem',

  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

export const InstallmentArea = styled('div')(() => ({
  gap: '0.5rem',
  flexDirection: 'column',
}));
